import { api } from './configs/axiosConfig'
import { defineCancelApiObject } from './configs/axiosUtils'

export const trackingApi = {
  getTrackingSendMethods: async function (cancel = false) {
    const response = await api.request({
      url: `${process.env.REACT_APP_GIANT_API_URL}/MetodoEnvioTracking/all`,
      method: "GET",
      withCredentials: true,
      signal: cancel ? cancelApiObject[this.get.name].handleRequestCancellation().signal : undefined,
    })

    return response.data.data
  },

  postTrackingForm: async function (trackingForm, cancel = false) {
    const response = await api.request({
      url: `${process.env.REACT_APP_GIANT_API_URL}/FormularioTracking/save`,
      method: "POST",
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
      data: trackingForm,
      signal: cancel ? cancelApiObject[this.get.name].handleRequestCancellation().signal : undefined,
    })

    return response.data
  }

}

const cancelApiObject = defineCancelApiObject(trackingApi)